export default __webpack_public_path__ + "static/media/6h.1da174de.png";